<template>
    <div class="margin-top-20">
        <div class="filter__section">
            <div class="row">
                <div class="col-md-6">
                    <!-- <div class="filter__title secondary-color-txt font-sanpro-semibold">Lớp</div> -->
                    <b-form-select v-model="paramQueryData.status" :options="listStatus">
                        <!-- <option value=0>Tất cả</option> -->
                    </b-form-select>
                </div>

            </div>
        </div>
        <div class="row header-table margin-top-10">
            <div class="col-header col-md-2">
                Tên
            </div>
            <div class="col-header col-md-2 text-center">
                Danh sách được giao
            </div>
            <div class="col-header col-md-2 text-center">
                Tỉ lệ hoàn thành
            </div>
            <div class="col-header col-md-2 text-center">
                Trạng thái
            </div>
            <div class="col-header col-md-3 text-center">
                Thời hạn
            </div>
            <div class="col-header col-md-1">

            </div>
        </div>
        <div class="list-data" v-if="listDataAssign.length > 0">
            <div class="row" v-for="(item, index) of listDataAssign" :key="index">
                <div class="col-cell col-md-2">
                    <router-link :to="{ path: getPath, query: { id: item.id, nameClass: nameClass, nameExcercise: item.name, classSchoolId: item.classSchoolId, listGroupId: item.listGroupId } }">
                        {{ item.name }}
                    </router-link>
                </div>
                <div class="col-cell col-md-2 text-center">
                    {{ item.listClassGroupName }}
                </div>
                <div class="col-cell col-md-2 text-center">
                    {{ item.countCompleted }}/{{ item.countMember }}
                </div>
                <div class="col-cell col-md-2 text-center">
                    {{ item.statusName }}
                </div>
                <div class="col-cell col-md-3 text-center">
                    <span class="col-table">{{ moment(item.duration).format('DD/MM/YYYY - HH:mm') }} 
                        <img @click="handleEditDuration(item)" class="icon-edit" src="@/assets/img/edit.png" />
                    </span>
                </div>
                <div @click="handleRecovery(item)" class="col-cell recover-assign col-md-1 text-center">
                    Thu hồi
                </div>
            </div>
        </div>
        <div v-else class="text-center empty-data mt-3">
            Bài tập/ bài kiểm tra đã giao chưa có dữ liệu
        </div>
        <div v-if="listDataAssign.length > 0" class="row pagination container m-0 mb-3">
            <b-pagination pills v-model="paramQueryData.pageIndex" :total-rows="totalRecords"
                :per-page="paramQueryData.pageSize" first-number last-number></b-pagination>
        </div>
        <ModalRecoveryAssign :dataLesson="dataLesson" :itemCurrentSelected="itemCurrentSelected" :type="paramQueryData.type"
            @closeModal="closeModalRecoveryAssign" @handelRecoveryDone="handelRecoveryDone"
            v-if="isOpenModalRecoveryAssign" />
        <ModalEditDuration @handleDone="handleDoneUpdateDuration" @closeModal="closeModalEditDuration"
            v-if="isOpenModalEditDuration" :type="paramQueryData.type" :item="itemCurrentSelected" />


    </div>
</template>
<script>
import moment from "moment"
import ModalRecoveryAssign from './ModalRecoveryAssign'
import { getListExcerciseTecherManager } from './../../_api/lessonClassSchoolUserServices';
import ModalEditDuration from './ModalEditDuration.vue'
export default {
    components: {
        ModalRecoveryAssign,
        ModalEditDuration,
    },
    props: {
        nameClass: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            chartData: {
        labels: [ 'January', 'February', 'March' ],
        datasets: [ { data: [40, 20, 12] } ]
      },
      chartOptions: {
        responsive: true
      },
            listStatus: [
                { value: 0, text: 'Trạng thái - Tất cả' },
                { value: 1, text: 'Kết thúc' },
                { value: 2, text: 'Đang diễn ra' },
            ],
            paramQueryData: {
                type: 3,
                classSchoolId: 0,
                pageIndex: 1,
                pageSize: 10,
                status: 0,
            },
            listDataAssign: [],
            totalRecords: 0,
            isOpenModalRecoveryAssign: false,
            isOpenModalEditDuration: false,
            dataLesson: {
                id: 0,
                name: ''
            },
            itemCurrentSelected: {
                id: 0,
                listGroupId: '',
                name: '',
                classSchoolId: 0
            },

        }
    },
    computed: {
        getPath() {
            return '/chi-tiet-bai-kiem-tra-da-giao'
        }
    },
    watch: {
        'paramQueryData.status': 'getListData',
        'paramQueryData.pageIndex': 'getListData'
    },
    mounted() {
        this.paramQueryData.classSchoolId = this.$route.query.id
        this.getListData()
    },
    methods: {
        moment,
        handleDoneUpdateDuration() {
            this.paramQueryData.pageIndex = 1
            this.getListData()
            this.closeModalEditDuration()
        },
        closeModalEditDuration() {
            this.isOpenModalEditDuration = false
        },
        handleEditDuration(item) {
            this.itemCurrentSelected = {
                listAssignLessonId: item.listAssignLessonId,
                listGroupId: item.listGroupId,
                name: item.listClassGroupName,
                classSchoolId: item.classSchoolId,
                duration:item.duration,
            }
            console.log(this.itemCurrentSelected)
            this.isOpenModalEditDuration = true

        },
        handelRecoveryDone() {
            this.paramQueryData.pageIndex = 1
            this.getListData()
            this.closeModalRecoveryAssign()
        },
        closeModalRecoveryAssign() {
            this.isOpenModalRecoveryAssign = false
        },
        handleRecovery(item) {
            console.log(item)
            this.dataLesson = {
                id: item.id,
                name: item.name
            }
            this.itemCurrentSelected = {
                id: item.id,
                listGroupId: item.listGroupId,
                name: item.listClassGroupName,
                classSchoolId: item.classSchoolId
            }
            this.isOpenModalRecoveryAssign = true
        },
        getListData() {
            let self = this
            getListExcerciseTecherManager(this.paramQueryData).then(res => {
                if (res && res.data && !res.errors) {
                    self.listDataAssign = res.data.list
                    self.totalRecords = res.data.paging.totalRecords
                }
            })
        },
    }
}
</script>
<style lang="scss" scoped>
.recover-assign {
    color: #ff4f62;
    cursor: pointer;
}

.margin-top-20 {
    margin-top: 20px;
}

.margin-top-10 {
    margin-top: 10px;
}

.header-table .col-header {
    color: #94a3b0;
}

.icon-edit {
    width: 15px;
    cursor: pointer;
}
</style>